// extracted by mini-css-extract-plugin
export default {"icon":"PlayerMarker_icon__BqahN","icon_inactive":"PlayerMarker_icon_inactive__ftfu5"};